"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _UpdateEspSync = _interopRequireDefault(require("settings-ui-modules/marketing/modules/esp-sync/stagedObjects/UpdateEspSync"));

var _default = (0, _redux.combineReducers)({
  updateEspSync: _UpdateEspSync.default.getReducer()
});

exports.default = _default;
module.exports = exports.default;